// ui_admin/src/index.js
import { App } from "./pages";
import { AuthProvider } from "react-oidc-context";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
// 1. Import the injection function you just created
import { injectStore } from "./api";
import reportWebVitals from "./reportWebVitals";
import { store } from "./../src/redux/store";

// 2. Inject the completely loaded store into your API instance
injectStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));

const oidcConfig = {
  authority: process.env.REACT_APP_AUTHORITY,
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  post_logout_redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  scope: "openid profile email offline_access",
  response_type: "code",
  automaticSilentRenew: true,
};

const onSigninCallback = (_user) => {
  window.history.replaceState({}, document.title, "/");
};

root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
      <Provider store={store}>
        <App />
      </Provider>
    </AuthProvider>
  </React.StrictMode>,
);

reportWebVitals();
